import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Phone, Mail, Clock, MapPin, ArrowUp, Linkedin, Youtube, Facebook, Instagram } from 'lucide-react';
import { company, services, navLinks, socials } from '../mock';

const socialIcon = { linkedin: Linkedin, youtube: Youtube, facebook: Facebook, instagram: Instagram };

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (e, href) => {
    e.preventDefault();
    const id = (href || '#home').replace('#', '');
    const scrollTo = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(scrollTo, 150);
    } else {
      scrollTo();
    }
  };

  return (
    <footer className="bg-[#081a34] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={company.logo} alt="Lockene" className="h-10 w-10 object-contain" />
            <span className="text-2xl font-extrabold font-display text-white">Lockene</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            India&rsquo;s trusted certification & compliance experts. We simplify government compliance for importers and manufacturers with expert BIS, ISI, CDSCO, WPC & more.
          </p>
          <div className="mt-5 flex items-center gap-3">
            {socials.map((s) => {
              const Icon = socialIcon[s.icon];
              return (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.name}
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-accent text-white flex items-center justify-center transition-colors"
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold font-display mb-4">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={(e) => goToSection(e, l.href)} className="hover:text-accent transition-colors cursor-pointer">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold font-display mb-4">Our Services</h4>
          <ul className="space-y-2.5 text-sm">
            {services.slice(0, 7).map((s) => (
              <li key={s.id}>
                <a href="#services" onClick={(e) => goToSection(e, '#services')} className="hover:text-accent transition-colors cursor-pointer">{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold font-display mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 text-accent mt-0.5" /><a href={`tel:${company.phoneRaw}`} className="hover:text-accent">{company.phone}</a></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-accent mt-0.5" /><a href={`mailto:${company.email}`} className="hover:text-accent">{company.email}</a></li>
            <li className="flex items-start gap-3"><Clock className="w-4 h-4 text-accent mt-0.5" /><span>{company.hours}</span></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-accent mt-0.5" /><span>Nagpur &bull; Mumbai &bull; Delhi</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <span>&copy; {new Date().getFullYear()} {company.name}. All rights reserved.</span>
          <a href="#home" onClick={(e) => goToSection(e, '#home')} className="flex items-center gap-2 hover:text-accent transition-colors cursor-pointer">Back to top <ArrowUp className="w-4 h-4" /></a>
        </div>
      </div>
    </footer>
  );
}
